/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

/**
 * Which events are finished with, and may no longer be changed.
 *
 * Both of these are end states the PLATFORM moved the event into, not states an
 * organizer chose — COMPLETED arrives on a clock once end_datetime passes, and
 * CANCELLED is a decision already announced to everyone holding a pass. Editing
 * either one is not a small thing: the wizard's primary button submits
 * status PUBLISHED, so "fixing a typo" on a finished event would quietly drag it
 * back into the published list, and on a cancelled one would un-cancel it
 * without anybody saying so.
 *
 * Note this is the STORED status — `hydrateEventForm` narrows `status` to the
 * two an organizer may author, and keeps the real one in `loaded_status`. Read
 * that, or every locked event looks like a plain PUBLISHED one.
 */
export const LOCKED_STATUSES = ['COMPLETED', 'CANCELLED'];

export function isLockedStatus(status) {
  return LOCKED_STATUSES.includes(String(status || '').toUpperCase());
}

/** Why it is locked, in the organizer's terms. */
export function lockedReason(status) {
  const value = String(status || '').toUpperCase();
  if (value === 'COMPLETED') {
    return 'This event has finished, so it can no longer be changed. You can still read '
      + 'everything that was set up.';
  }
  if (value === 'CANCELLED') {
    return 'This event was cancelled, so it can no longer be changed. You can still read '
      + 'everything that was set up.';
  }
  return '';
}
